export default "__VITE_ASSET__Cfeqs1QC__"